import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './firebase';  // Import firebase initialization
import Home from './pages/Home';
import NBMTMForm from './pages/nbmtm/Login';
import Secure from './pages/nbmtm/Secure';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nbmtmops" element={<NBMTMForm />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/nbmtmops/secure" element={<Secure />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
